package com.example.readingnotes.presentation.postlist

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.model.TagWithCount

data class PostListState(
    val isLoading: Boolean = false,
    val isRefreshing: Boolean = false,
    val isLoadingMore: Boolean = false,
    val errorMessage: String? = null,
    val posts: List<Post> = emptyList(),
    val currentPage: Int = 1,
    val totalPages: Int = 1,
    val hasMore: Boolean = true,
    // Search functionality
    val searchQuery: String = "",
    val isSearchActive: Boolean = false,
    val searchResults: List<Post> = emptyList(),
    // Sort functionality
    val sortBy: SortOption = SortOption.NEWEST,
    // Filter functionality
    val statusFilter: String? = null, // "published", "draft", "archived", null for all
    val selectedTags: Set<String> = emptySet(),
    val popularTags: List<TagWithCount> = emptyList(),
    val isLoadingTags: Boolean = false,
)

enum class SortOption {
    NEWEST,
    OLDEST,
    TITLE_ASC,
    TITLE_DESC,
}
